// extracted by mini-css-extract-plugin
module.exports = {"container":"nextAvailableSlot_container__2XvvK","noAppointments":"nextAvailableSlot_noAppointments__waobA","link":"nextAvailableSlot_link__3o5E9"};